export default __webpack_public_path__ + "static/revops 3-4aabf8d27f688d4e491c579d1ffbb869.png";